import { selectFromVisitDto } from '../../models';

const PendingVisitQuery = selectFromVisitDto()
  .id
  .uuid
  .name
  .eventUuid
  .projectId
  .isScheduling
  .isUnscheduling
  .isDeleting
  .pendingTargetRouteUuid
  .isCompleted
  .isScheduled
  .routificOrderNumber
  .customerOrderNumber
  .scheduledEvent(evnt => evnt
    .route(route => route
      .id
      .name
      .hexColor,
    ))
  .locations(b => b
    .address
    .originalAddress
    .latitude
    .longitude
    .locationStatusId
    .active
    .bestMatch)
  .toString();

export default PendingVisitQuery;
